module.exports = __webpack_public_path__ + "static/10-3-bb3f9503a0686703f217c6f09096e283.jpg";